module.exports = __webpack_public_path__ + "static/background-fb54758aea0da7360a8fddc43b568cbe.png";